if (!customElements.get('s-featured-products')) {
  customElements.define('s-featured-products', class SectionFeaturedProducts extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.swiper = new Swiper('.s-featured-products__list', {
          // Default parameters
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            prevEl: ".js-featured-products__button--prev",
            nextEl: ".js-featured-products__button--next",
          },
          // Responsive breakpoints
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 1.3,
              spaceBetween: 9
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 2,
            },
            // when window width is >= 640px
            640: {
              slidesPerView: 2.5,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 6
            },
            1200: {
              slidesPerView: 5,
            }
          }
        })


        this.slideChanger();
        this.swiper.on("resize", this.slideChanger)

        this.swiper.on("slideChange", this.slideChanger)

      }

      disconnectedCallback() {
       
      }
    
      slideChanger = () => {
        let currentSlideWrapper = this.querySelector(".s-featured-products__current-slide");
        currentSlideWrapper.innerText = this.swiper.activeIndex + 1;
      }
    }
  );
}
